// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"f53e1369","191":"413b26a4","209":"d464d894","278":"1496f5ca","312":"a89dcbe9","478":"1e89ce4b","562":"816adbad","689":"ca67d84e","922":"fefd4601","964":"2e74df65"}[chunkId] + ".chunk.js";
};